<ng-container *ngIf="quickLinksNodes$ | async as quickLinksNodes">
  <ng-container *ngIf="quickLinksNodes.size > 0">
    <div class="ds-grid">
      <div class="justify-content-center row">
        <div class="col-md-9 px-sm-0 quick-links-col">
          <div class="quick-links-component row mt-6 mb-4 mb-sm-6">
            <ng-container *ngFor="let quickLinksNodesKeyVal of navigationComponentService.mapToArray(quickLinksNodes)">
              <ng-container *ngFor="let quickLink$ of quickLinksNodesKeyVal">
                <ng-container *ngIf="quickLink$ | async as quickLink">
                  <div *ngIf="quickLink.url"
                       class="quick-links-component__entry-container col-sm-4 mb-5 mb-sm-0 px-sm-2 px-md-4">
                    <div class="quick-links-component__entry-container__entry">
                      <div class="quick-links-component__entry-container__entry__name ds-heading--s mb-sm-4">
                        <span>{{quickLink.name}}</span>
                      </div>
                      <ng-container *ngIf="quickLink.url">
                        <cx-generic-link [url]="quickLink.url" [target]="quickLink.target"
                                         class="quick-links-component__entry-container__entry__link btn btn-link p-0">
                          <span>{{quickLink.linkName}}</span>
                          <em class="ds-icon ds-icon--arrow-right"></em>
                        </cx-generic-link>
                      </ng-container>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </ng-container>
          </div>
        </div>
      </div>
    </div>
    <div class="separator w-100"></div>
  </ng-container>
</ng-container>
